import { DeviceAlertConstant as DeviceConstants } from '../redux_constants/device.constant';
import { delay, call} from 'redux-saga/effects'
import cookie from "react-cookies";
import {get_response} from "../helper/request";

function* pollStatus(dispatch, id) {
    while (cookie.load('token')) {
        try {
            yield call(() => dispatch(getDeviceStatus(id)));
            yield delay(2000);
        } catch (err) {
            console.log(err);
        }
    }
}

export const watchPollStatus = function* (dispatch, id) {
    while (cookie.load('token')) {
        yield call(pollStatus, dispatch, id);
    }
}

export const setDeviceBusy = (id, message) => ({
    type: DeviceConstants.SET_DEVICE_UI_BUSY,
    id: id, 
    busyMessage: message === undefined ? "..." : message,
})

export const setDeviceIdle = (id) => ({
    type: DeviceConstants.SET_DEVICE_UI_IDLE,
    id: id
})

export const receivedDeviceStatus = (type, response, id) => ({
    type: type,
    response: response,
    id: id
})

export const getDeviceStatus = (id) => (dispatch) => {
    let url = `/server/devices/` + id + '/poll_scanner_status/';
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch(receivedDeviceStatus(DeviceConstants.RECEIVED_DEVICE_STATUS, response, id));
            }
        })
        .catch(err => {
            dispatch(receivedDeviceStatus(DeviceConstants.FAILED_TO_RECEIVE_DEVICE_STATUS, err, id))
            console.log(err)
        })
}

